var map = {
	"./ca/dark/en": 40419,
	"./ca/dark/en.json": 40419,
	"./ca/dark/fr": 84536,
	"./ca/dark/fr.json": 84536,
	"./ca/light/en": 30357,
	"./ca/light/en.json": 30357,
	"./ca/vuse_world": 8649,
	"./ca/vuse_world.json": 8649,
	"./de/de": 79409,
	"./de/de.json": 79409,
	"./gb/en": 5799,
	"./gb/en.json": 5799,
	"./gb/en/en": 47107,
	"./gb/en/en.json": 47107,
	"./za/en": 86147,
	"./za/en.json": 86147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98629;